
let data =  {
    "logo": "https://i01.appmifile.com/webfile/globalimg/pandora/mi-logo.svg",
    "banner": {
          "start": [
                {
                  img : "https://i02.appmifile.com/871_operator_in/06/09/2022/1d4923aadec41ba9671ee521bf7039ed.jpg",
                  url : "https://www.mi.com/in/buy/product/redmi-a1?notify=1"
            },
                {
                  img : "https://i02.appmifile.com/758_operator_in/06/09/2022/9c7b554158f3ae80100d7a3bdf20bb6e.jpg",
                  url : "https://www.mi.com/in/buy/product/redmi-11-prime-5g?notify=1"
            },
                {
                  img : "https://i02.appmifile.com/736_operator_in/05/09/2022/c3423d09aca5c630ef022fdaddc904b3.gif",
                  url : "https://in.event.mi.com/in/xiaomi-grooming-kit-pro"
            },
                {
                  img : "https://i02.appmifile.com/35_operator_in/06/09/2022/692f3d2c253fe635ffe5b13ce480820b.jpg",
                  url : "https://www.mi.com/in/buy/product/redmi-11-prime-4g?notify=1"
            },
                {
                  img : "https://i02.appmifile.com/185_operator_in/06/09/2022/c4ee81effd264b788904fc8dee4a3980.png",
                  url : "https://www.mi.com/in/buy/product/redmi-note-11-se"
            },
                {
                  img : "https://i02.appmifile.com/275_operator_in/06/09/2022/d6cfeb4b87a08e98ba74799e24174324.jpg",
                  url : "https://www.mi.com/in/buy/product/xiaomi-11t-pro-5g"
            },
                {
                  img : "https://i02.appmifile.com/700_operator_in/06/09/2022/da32a57c7452f3e6825a9f68ba6d72d6.jpg",
                  url : "https://www.mi.com/in/buy/product/mi-tv-5x-series"
            },
                {
                  img : "https://i02.appmifile.com/392_operator_in/06/09/2022/deb4764c33deec84605b392907d479e6.jpg",
                  url : "https://in.event.mi.com/in/laptop-store"
            },
          ],
          "end": [
                {
                      "name": "REDMI NOTE 11S",
                      "description": "This phone has a liquid cooling technology which is very rare at this price point. Xiaomi has paid a lot of attention to managing thermals on this phone ",
                      "source": " source : C4E Tech",
                      "image": "https://i02.appmifile.com/500_operator_in/23/02/2022/7dd77194a09db35f46aa82541d30a6f2.jpg",
                      'url' : 'https://www.youtube.com/watch?v=wLUtb9AU8GI'
                },
                {
                      "name": "REDMI NOTE 11",
                      "description": "Redmi Note 11 comes in a Starburst White colour with a glittery back throwing shades of blue. Despite the glossy texture, the choice of colour helps hide the fingerprint smudges.",
                      "source": " source : Money Control",
                      "image": "https://i02.appmifile.com/794_operator_in/23/02/2022/29f71b53b9eeba2c95f4ca2ca39b48f8.jpg",
                      'url' : 'https://www.moneycontrol.com/news/photos/technology/redmi-note-11-review-price-india-specifications-budget-smartphone-under-rs-15000-8052931.html'
                },
                {
                      "name": "REDMI SMART BAND PRO SPORTS WATCH",
                      "description": "It looks really cool and comes built like a tank with 5 ATM water resistance. This means you can use it in the rain or while swimming",
                      "source": " source : Technolobe",
                      "image": "https://i02.appmifile.com/154_operator_in/23/02/2022/6402f385dba2e95d1d5a9d250cbf7c8d.jpg",
                      'url' : 'https://www.youtube.com/watch?v=yFWsph7v0tg'
                },
                {
                      "name": "XIAOMI 11T PRO 5G",
                      "description": "Xiaomi turned the 11T Pro’s display into a multimedia monster with a true 6.67-inch 10-bit display capable of outputting 1 billion colours.",
                      "source": " source : My SmartPrice",
                      "image": "https://i02.appmifile.com/395_operator_in/01/02/2022/89c7d2292f1bafd3b403439df9bd874f.jpg",
                      'url' : 'https://www.mysmartprice.com/gear/xiaomi-11t-pro-first-impressions-review/'
                },
                {
                      "name": "XIAOMI 11I SERIES",
                      "description": "The Xiaomi 11i Hypercharge sets a new benchmark with its 120W fast charging solution which is capable of topping up the phone’s battery in no time",
                      "source": " source : Digit",
                      "image": "https://i02.appmifile.com/8_operator_in/01/02/2022/e9853b271494b6f3e9d73ff0cbd65aa6.jpg",
                      'url' : 'https://www.digit.in/reviews/mobile-phones/xiaomi-11i-hypercharge-review-258793.html'
                },
                {
                      "name": "MI TV 5X SERIES",
                      "description": "The big 4K panel goes edge-to-edge offering a 96.6% screen-to-body ratio to offer an immersive bezel-less viewing experience",
                      "image": "https://i02.appmifile.com/108_operator_in/13/01/2021/3bfe5123ede27524d616f0bdaf43945a.jpg",
                      "source":" source : Gizbot",
                      'url' : 'https://www.gizbot.com/home-entertainment/reviews/xiaomi-mi-tv-5x-55-first-impressions-the-good-the-bad-the-x-factor-076583.html'
                },
          ]
    },
    "offer": [
          {
                "url": "https://in.event.mi.com/in/redmi-11-prime-series-coming-soon",
                "image": "https://i02.appmifile.com/805_operator_in/04/09/2022/372dd6766aa1a54851491ee9a9bda87b.jpg?width=398&height=230"
          },
          {
                "url": "https://in.event.mi.com/in/redmi-a1-coming-soon",
                "image": "https://i02.appmifile.com/731_operator_in/05/09/2022/1e621309e28c5165d695fc0bbf228b59.jpg?width=398&height=230"
          },
          {
                "url": "https://www.mi.com/in/live/redmi-launch/",
                "image": "https://i02.appmifile.com/95_operator_in/06/09/2022/d8bf347058c982bce8c33c580d54e2e2.jpg?width=398&height=230"
          }
    ],
    "starProduct": [
          {
                "url": "https://www.mi.com/in/xiaomi-12-pro-5g",
                "image": "https://i02.appmifile.com/353_operator_in/17/05/2022/b920ec46e9322a9e85e4c2b648d3eedb.jpg?width=612&height=612"
          },
          {
                "url": "https://www.mi.com/in/buy/product/mi-notebook-pro",
                "image": "https://i02.appmifile.com/955_operator_in/11/07/2022/c4237dc3ff900106f0f9be5b8519f636.jpg?width=612&height=612"
          },
          {
                "url": "https://in.event.mi.com/in/xiaomi-11i-series-5g-2022",
                "image": "https://i02.appmifile.com/90_operator_in/11/03/2022/9b1ab6de9e17724d9f1fcde70dac3b4c.jpg?width=612&height=612"
          },
          {
                "url": "https://www.mi.com/in/product/xiaomi-oled-vision-tv",
                "image": "https://i02.appmifile.com/814_operator_in/28/06/2022/f9cdd947ff7d4f4704729801efc92568.jpg?width=612&height=612"
          }
    ],
    "hotAccessories": {
          "music": [
                {
                      "name": "Redmi Earbuds S",
                      "price": "₹ 1,799",
                      "image": "https://i01.appmifile.com/webfile/globalimg/in/cms/BF2A4279-A6D5-B4F0-FE37-633256CDC9FC.jpg",
                      "url": "https://store.mi.com/in/search_Redmi%20Earbuds%20S"
                },
                {
                      "name": "Mi Soundbar",
                      "price": "₹ 4,999",
                      "image": "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1547107203.76021206.png",
                      "url" : 'https://store.mi.com/in/search_Mi%20Soundbar'
                },
                {
                      "name": "Mi Neckband Bluetooth Earphones",
                      "price": "₹ 1,599",
                      "image": "https://i01.appmifile.com/webfile/globalimg/in/cms/A1C40BA8-574D-2FA0-62C0-3D7A2C964790.jpg",
                      "url" : "https://store.mi.com/in/search_Mi%20Neckband%20Bluetooth%20Earphones"
                },
                {
                      "name": "Mi Super Bass Wireless Headphones",
                      "price": "₹ 1,799",
                      "image": "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1563264530.44121333.jpg?width=420&height=420"
                      ,'url' : 'https://store.mi.com/in/search_Mi%20Super%20Bass%20Wireless%20Headphones'
                },
                {
                      "name": "Mi Dual Driver In-ear Earphones",
                      "price": "₹ 799",
                      "image": "https://i01.appmifile.com/webfile/globalimg/in/cms/E794F82C-8858-02F1-7C53-6FB0B4D0C4C6.jpg"
                      ,'url' : 'https://store.mi.com/in/search_Mi%20Dual%20Driver%20In-ear%20Earphones'
                }
          ],
          "smartDevice": [
                {
                      "name": "Mi Smart Band 4",
                      "price": "₹ 2,099",
                      "image": "https://i01.appmifile.com/webfile/globalimg/in/cms/0E0F0769-6A69-5820-C8F0-F2B956C65BFA.jpg"
                      ,'url' : 'https://store.mi.com/in/search_Mi%20Smart%20Band%204'
                },
                {
                      "name": "Mi Smart Water Purifier",
                      "price": "₹ 12,999",
                      "image": "https://i01.appmifile.com/webfile/globalimg/in/cms/BC643CF4-853C-24E4-1EEC-9D4FF614C86D.jpg"
                      ,'url' : 'https://store.mi.com/in/search_Mi%20Smart%20Water%20Purifier'
                },
                {
                      "name": "Mi Watch Revolve",
                      "price": "₹ 9,999",
                      "image": "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1601293021.06313819.png"
                      ,'url' : 'https://store.mi.com/in/search_Mi%20Watch%20Revolve'
                },
                {
                      "name": "Mi Smart Bedside Lamp 2",
                      "price": "₹ 2,499",
                      "image": "https://i01.appmifile.com/webfile/globalimg/in/cms/6A656178-B31B-39D1-AC43-9C7EC61C3D84.jpg"
                      ,'url' : 'https://store.mi.com/in/search_Mi%20Smart%20Bedside%20Lamp%202'
                },
                {
                      "name": "Mi Smart LED Desk Lamp 1S",
                      "price": "₹ 2,499",
                      "image": "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1574669860.58966823.jpg?width=420&height=420"
                      ,'url' : 'https://store.mi.com/in/search_Mi%20Smart%20LED%20Desk%20Lamp%201S'
                }
          ],
          "home": [
                {
                      "name": "Mi Air Purifier 3",
                      "price": "₹ 10,999",
                      "image": "https://i01.appmifile.com/webfile/globalimg/in/cms/70A72569-C7EA-BBD7-591E-DC93EC3CDF34.jpg"
                      ,'url' : 'https://store.mi.com/in/search_Mi%20Air%20Purifier%203'
                },
                {
                      "name": "Mi Air Purifier 2C",
                      "price": "₹ 6,999",
                      "image": "https://i01.appmifile.com/webfile/globalimg/in/cms/7D8FAD13-1E44-9475-3555-949CBF3571AF.jpg"
                      ,'url' : 'https://store.mi.com/in/search_Mi%20Air%20Purifier%202C'
               },
                {
                      "name": "Mi Router 4C",
                      "price": "₹ 999",
                      "image": "https://i01.appmifile.com/webfile/globalimg/in/cms/FD13B2EB-1AD5-67EE-FF6B-C3E2A0270556.jpg"
                      ,'url' : 'https://store.mi.com/in/search_Mi Router 4C'
                },
                {
                      "name": "Mi Box 4K",
                      "price": "₹ 3,499",
                      "image": "https://i02.appmifile.com/919_updatepdf_in/15/05/2020/984e626e158fdeb7cc21aff04264773d.png"
                      ,'url' : 'https://store.mi.com/in/search_Mi%20Box%204K'
                },
                {
                      "name": "Mi LED Wi-Fi Smart Bulb",
                      "price": "₹ 1,299",
                      "image": "https://i01.appmifile.com/webfile/globalimg/in/cms/441FC065-EEE7-5A64-9CF9-608EF2F82F60.jpg"
                      ,'url' : 'https://store.mi.com/in/search_Mi%20LED%20Wi-Fi%20Smart%20Bulb'
                }
          ],
          "lifeStyle": [
                {
                      "name": "Mi Travel Backpack",
                      "price": "₹ 1,999",
                      "image": "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1536381648.16353261.png?width=420&height=420"
                      ,'url' : 'https://store.mi.com/in/search_Mi%20Travel%20Backpack'
                },
                {
                      "name": "Mi Athleisure Shoes",
                      "price": "₹ 1,699",
                      "image": "https://i02.appmifile.com/363_operator_in/13/10/2020/c7bde508f128d7b1fd10a224d18a5333.png"
                      ,'url' : 'https://store.mi.com/in/search_Mi%20Athleisure%20Shoes"'
                },
                {
                      "name": "Mi Beard Trimmer",
                      "price": "₹ 1,399",
                      "image": "https://i01.appmifile.com/webfile/globalimg/in/cms/CEEE67A3-3578-7048-887D-CFC3D90B5D17.jpg"
                      ,'url' : 'https://store.mi.com/in/search_Mi%20Beard%20Trimmer'
                },
                {
                      "name": "Mi KN-95 Protective Mask (Pack of 5)",
                      "price": "₹ 399",
                      "image": "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1602500062.48215120.png?width=420&height=420"
                      ,'url' : 'https://store.mi.com/in/search_Mi%20KN-95%20Protective%20Mask%20(Pack%20of%205)'
                },
                {
                      "name": "Mi Portable Electric Air Compressor",
                      "price": "₹ 2,499",
                      "image": "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1592479075.0368979.png?width=420&height=420"
                      ,'url' : 'https://store.mi.com/in/search_Mi%20Portable%20Electric%20Air%20Compressor'
                },
                {
                      "name": "Mi T-shirts",
                      "price": "₹ 399 onwards",
                      "image": "https://i01.appmifile.com/webfile/globalimg/in/cms/0D320403-6180-D6D6-9F57-4EDF0FEB58C7.jpg"
                      ,'url' : 'https://store.mi.com/in/search_shirt'
                }
          ],
          "mobileAccessories": [
                {
                      "name": "Cases & Covers",
                      "price": "₹ 49 onwards",
                      "image": "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1551164869.57618003.jpg"
                      ,'url' : 'https://store.mi.com/in/search_Cover'
                },
                {
                      "name": "Charger & USB Gadgets",
                      "price": "₹ 179 onwards",
                      "image": "https://i01.appmifile.com/webfile/globalimg/in/cms/5A5AA9AC-41A3-7E86-5922-928B312919B0.jpg"
                      ,'url' : 'https://store.mi.com/in/search_Charger'
                },
                {
                      "name": "Mi Wireless Power Bank 10000mAh",
                      "price": "₹ 2,499",
                      "image": "https://i01.appmifile.com/webfile/globalimg/in/cms/3CBAACCE-D18A-B241-A4F8-54A4CCE194A5.jpg"
                      ,'url' : 'https://store.mi.com/in/search_Mi%20Wireless%20Power%20Bank%2010000mAh'
                },
                {
                      "name": "10000mAh Mi Power Bank 3i",
                      "price": "₹ 999",
                      "image": "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1600434881.35114664.jpg?width=420&height=420"
                      ,'url' : 'https://store.mi.com/in/search_10000mAh%20Mi%20Power%20Bank%203i'
                },
                {
                      "name": "Redmi SonicBass Wireless Earphones",
                      "price": "₹ 1,299",
                      "image": "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1601900775.75794078.png?width=420&height=420"
                      ,'url' : 'https://store.mi.com/in/search_Redmi%20SonicBass%20Wireless%20Earphones'
                }
          ]
    },
    "hotAccessoriesCover": {
          "music": "https://i01.appmifile.com/webfile/globalimg/in/cms/500BFA0B-CBEF-5DFF-79A9-E925F9F2FEE9.jpg",
          "smartDevice": "https://i02.appmifile.com/953_operator_in/17/06/2021/e12dde416676486fed36d0503d5bd65a.jpg",
          "home": "https://i02.appmifile.com/663_operator_in/20/01/2021/0f6ac3c219428b6decbe7fb03d479060.jpg",
          "lifeStyle": "https://i02.appmifile.com/677_operator_in/25/01/2021/8163c3c89feb2c83c73b019d5fd50181.jpg",
          "mobileAccessories": "https://i01.appmifile.com/webfile/globalimg/in/cms/801ED76B-614B-5959-E2C3-1EC8E14C0ABD.jpg"
    },
    "productReviews": [
          {
                "image": "https://i02.appmifile.com/259_operator_in/04/02/2022/f76f28e3d4f5b1fce78d461e12e00bc7.jpg?width=606&height=252",
                "review": "ALL ABOUT PERFORMANCE!",
                "name": "REDMI NOTE 11T 5G ",
                "price": "₹ 16,999",
                "url":"https://gadgets.ndtv.com/mobiles/reviews/redmi-note-11t-5g-xiaomi-review-price-in-india-performance-cameras-2638972"
          },
          {
                "image": "https://i02.appmifile.com/149_operator_in/04/02/2022/7f9762559b5d78130b310719d37daaea.jpg?width=606&height=252",
                "review": "YOUR HOME-GUARD WITH HIGH RESOLUTION!",
                "name": "MI HOME SECURITY CAMERA 2K PRO  ",
                "price": "₹ 4,499",
                "url": 'https://www.91mobiles.com/hub/mi-360-home-security-camera-2k-pro-review/'
          }
    ],
    "videos": [
          {
                "name": "Redmi Note 10 Pro Max",
                "image": "https://i02.appmifile.com/741_operator_in/07/02/2022/81abe053200c37736e75e090d32a5bcc.jpg?width=398&height=320",
                'url': 'https://youtu.be/TKpW-qdfpYk'
          },
          {
                "name": "Xiaomi OLED Vision TV 55",
                "image": "https://i02.appmifile.com/181_operator_in/20/07/2022/089be547af3dce9aab7d3538bdc3ff72.jpg?width=398&height=320",
                'url': 'https://youtu.be/fL4XkAIa-48'
          },
          {
                "name": "Xiaomi 11 lite NE 5G",
                "image": "https://i02.appmifile.com/327_operator_in/07/02/2022/244bfd0645de5e7015460321203eb1f8.jpg?width=398&height=320",
                'url': 'https://youtu.be/QUnvwB7upsw'
          }
    ],
    "footer": {
          "support": [
                {
                      "name": "Online Help",
                      "url": "https://www.mi.com/in/service/help/#category_id=1&pagenum=1&channel=1"
                },
                {
                      "name": "Customer Service",
                      "url": "https://www.mi.com/in/service/online/"
                },
                {
                      "name": "Shipping FAQ",
                      "url": "https://www.mi.com/in/service/shipping/"
                },
                {
                      "name": "Service Centres",
                      "url": "https://www.mi.com/in/service/repair/"
                },
                {
                      "name": "Warrenty",
                      "url": "https://www.mi.com/in/service/warranty/"
                },
                {
                      "name": "Mi Exchange",
                      "url": "https://www.mi.com/in/miexchange/"
                },
                {
                      "name": "Bulk Order",
                      "url": "https://www.mi.com/in/bulkbuy/"
                },
                {
                      "name": "User Guide",
                      "url": "https://www.mi.com/in/service/userguide/"
                },
                {
                      "name": "Laptop Drivers",
                      "url": "https://www.mi.com/in/service/support/laptop-drivers.html"
                },
                {
                      "name": "Mi Screen Protect",
                      "url": "https://www.mi.com/in/service/miphoneprotection/#miscreenprotect"
                },
                {
                      "name": "Mi Extended Warranty",
                      "url": "https://www.mi.com/in/service/miextendedwarranty/"
                }
          ],
          "shopAndLearn": [
                {
                      "name": "Mi 10i",
                      "url": "https://www.mi.com/in/mi-10i/"
                },
                {
                      "name": "Mi 10T Series",
                      "url": "https://in.event.mi.com/in/mi-10t-series"
                },
                {
                      "name": "Mi 11 Ultra",
                      "url": "https://www.mi.com/in/mi-11-ultra/"
                },
                {
                      "name": "Mi 11X",
                      "url": "https://www.mi.com/in/mi-11x/"
                },
                {
                      "name": "Mi 11X Pro",
                      "url": "https://www.mi.com/in/mi-11x-pro/"
                },
                {
                      "name": "Redmi 8",
                      "url": "https://www.mi.com/in/redmi-8/"
                },
                {
                      "name": "Redmi 9",
                      "url": "https://www.mi.com/in/redmi-9/"
                },
                {
                      "name": "Redmi 9 Prime",
                      "url": "https://www.mi.com/in/redmi-9-prime/"
                },
                {
                      "name": "Redmi 9i",
                      "url": "https://www.mi.com/in/redmi-9i/"
                },
                {
                      "name": "Redmi 9A",
                      "url": "https://www.mi.com/in/redmi-9a/"
                },
                {
                      "name": "Redmi Note 10",
                      "url": "https://www.mi.com/in/redmi-note-10/"
                },
                {
                      "name": "Redmi Note 10 Pro",
                      "url": "https://www.mi.com/in/redmi-note-10-pro/"
                },
                {
                      "name": "Redmi Note 10 Pro Max",
                      "url": "https://www.mi.com/in/redmi-note-10-pro-max/"
                },
                {
                      "name": "Redmi Note 9 Pro",
                      "url": "https://www.mi.com/in/redmi-note-9-pro/"
                },
                {
                      "name": "Redmi Note 9",
                      "url": "https://www.mi.com/in/redmi-note-9/"
                },
                {
                      "name": "Redmi Note 9 Pro Max",
                      "url": "https://www.mi.com/in/redmi-note-9-pro-max/"
                },
                {
                      "name": "TVs",
                      "url": "https://www.mi.com/in/all-mi-tv"
                },
                {
                      "name": "Laptops",
                      "url": "https://www.mi.com/in/xiaomi-laptops"
                }
          ],
          "retailStore": [
                {
                      "name": "Mi Home",
                      "url": "https://www.mi.com/in/service/mihome/"
                },
                {
                      "name": "Mi Authorised Stores",
                      "url": "https://www.mi.com/in/service/authorized_stores/"
                }
          ],
          "aboutUS": [
                {
                      "name": "Xioami",
                      "url": "https://www.mi.com/in/about/"
                },
                {
                      "name": "Mediakit",
                      "url": "https://www.mi.com/in/mediakit/"
                },
                {
                      "name": "Culture",
                      "url": "https://www.mi.com/in/about/#culture"
                },
                {
                      "name": "User Agreement",
                      "url": "https://www.mi.com/in/about/agreement/"
                },
                {
                      "name": "Privacy Policy",
                      "url": "https://www.mi.com/in/about/privacy/"
                },
                {
                      "name": "Declarations",
                      "url": "https://www.mi.com/in/service/support/mideclare.html"
                },
                {
                      "name": "Integrity & Compliance",
                      "url": "https://integrity.mi.com/global"
                },
                {
                      "name": "Smartphone Quality",
                      "url": "https://www.mi.com/in/smartphone-quality/"
                },
                {
                      "name": "TV Quality",
                      "url": "https://www.mi.com/in/tv-quality/"
                },
                {
                      "name": "Service Quality",
                      "url": "https://www.mi.com/in/service-quality/"
                },
                {
                      "name": "Environment",
                      "url": "https://www.mi.com/in/service/support/ewastetakeback.html"
                },
                {
                      "name": "Sitemap",
                      "url": "https://www.mi.com/in/sitemap"
                }
          ],
          "contactUs": [
                {
                      "name": "Email",
                      "url": "https://in.event.mi.com/in/questionnaire/email_us"
                },
                {
                      "name": "Careers",
                      "url": "https://www.mi.com/in/about/#career"
                }
          ]
    }
}

// key = [1,2,3,4,5,6,7,8,9,10]

export default data;